export default __webpack_public_path__ + "6db0d48658aa9e1715ac8acce8c95fc2.png";